import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import * as elIcons from '@element-plus/icons-vue'
import {GET, POST, POST1, down,ERROR,PUT,POSTSTREAM} from './utils/api'
import tools from './utils/tools'
import verify from './utils/verify'
import dayjs from './utils/dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import svgIcon from '@/components/svgIcon.vue'
import echarts from "./utils/echarts";
import {installActivePageSessionSync} from './utils/activePageSession'
// import VConsole from 'vconsole';
// const vConsole = new VConsole({ theme: 'dark' })

async function start() {
    const app = createApp(App);

    app.use(router);        //使用路由
    app.use(store);         //使用vuex
    app.use(ElementPlus, {
        locale: zhCn,
        zIndex: 5000,
    });                     //使用element

    installActivePageSessionSync({router, store});

    //注册全局icon图标组件
    for (const [key, component] of Object.entries(elIcons)) {
        app.component(key, component)
    }

    //鉴权指令
    tools.accessDirective(app);
    //防抖指令
    tools.antiShakeDirective(app);

    app.mount('#app');

    // 配置全局属性
    app.config.globalProperties.$GET = GET;
    app.config.globalProperties.$POST = POST;
    app.config.globalProperties.$POST1 = POST1;
    app.config.globalProperties.$PUT = PUT;
    app.config.globalProperties.$down = down;
    app.config.globalProperties.$ERROR = ERROR;
    app.config.globalProperties.$POSTSTREAM = POSTSTREAM;
    app.config.globalProperties.$tools = tools;
    app.config.globalProperties.$verify = verify;
    dayjs.extend(isBetween);
    app.config.globalProperties.$dayjs = dayjs;
    app.config.globalProperties.$echarts = echarts;

    //获取全局异常
    // app.config.errorHandler = function (err, vm, info) {
    //     console.log('全局捕获 err >>>', err)
    //     console.log('全局捕获 vm >>>', vm)
    //     console.log('全局捕获 info >>>', info)
    //     //打印日志
    //     console.error(err, vm, info)
    //
    //     //发送给后台(日志信息,版本号)
    // };


    //region 设置svg组件
    app.component('svg-icon', svgIcon);
    const requireAll = requireContext => requireContext.keys().map(requireContext);
    const req = require.context('./assets/icons', false, /\.svg$/);
    requireAll(req)
    //endregion

}
start();
